import { render, staticRenderFns } from "./VideoSlide.vue?vue&type=template&id=64c845ff"
import script from "./VideoSlide.vue?vue&type=script&lang=js"
export * from "./VideoSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64c845ff')) {
      api.createRecord('64c845ff', component.options)
    } else {
      api.reload('64c845ff', component.options)
    }
    module.hot.accept("./VideoSlide.vue?vue&type=template&id=64c845ff", function () {
      api.rerender('64c845ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/player/layerContent/VideoSlide.vue"
export default component.exports